// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer-container{
    background-color: #E42727;
    margin:0;
    padding: 0;
    box-sizing: border-box;
}

.footer{
background-color: #E42727;
display: flex;
margin: 0;

}




.brand-container{
    width:30%;
    padding:50px;
    border-right: none;
    border-style:none;
    border-width: 0.005px;
    border-left:none;
    border-top:none;
    border-bottom:rgba(0, 0, 0, 0.1);

}
.brand-container img{
    width:80%;
}

.brand-container p{
    font-family: 'Inter',sans-serif;
    font-weight: 400;
    font-size:14px;
    color:#ffffff;
    text-align:center;
    line-height: 22px;
    margin-top: -10px;
    letter-spacing: 1px;
}
.brand-container h5 {
    font-family: 'Inter', sans-serif;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    text-align: center;
    line-height: 22px;
    
    letter-spacing: 1px;
}

.social{
    width:50%;
    display: flex;
    justify-content: space-evenly;
    margin-left:20%;
    cursor: pointer;
    
}

.links{
    display: flex;
    flex-direction: column;
    margin-left: 30px;
    justify-content:start;
    margin-top: 150px;
}

.links h5{
    font-family: 'Inter',sans-serif;
    font-weight: 700;
    font-size: 14px;
    letter-spacing: 1px;
    text-align: left;
    color:#ffffff;
}
.links a {
    font-family: 'Inter', sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    letter-spacing: 1px;
    text-align: left;
    color: #ffffff;
}

.links-one {
    display: flex;
    flex-direction: column;
    margin-left: 30px;
    justify-content: start;
    margin-top: 150px;
}

.links-one h5 {
    font-family: 'Inter', sans-serif;
    font-weight: 700;
    font-size: 14px;
    letter-spacing: 1px;
    text-align: left;
    color: #ffffff;
}

.links-one a {
    font-family: 'Inter', sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    letter-spacing: 1px;
    text-align: left;
    color: #ffffff;
    
}

.contact-details {
    display: flex;
    width:fit-content;
    flex-direction: column;
    margin-left: 0px;
    align-items:center;
    justify-content:start;
    margin-top: 150px;
}

.contact-details h5 {
    font-family: 'Inter', sans-serif;
    font-weight: 700;
    font-size: 14px;
    letter-spacing: 1px;
    line-height: 22px;
    text-align: left;
    color: #ffffff;
}

.contact-details p {
    font-family: 'Inter', sans-serif;
    width:80%;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    letter-spacing: 1px;
    text-align: center;
    margin-top: 0px;
    color: #ffffff;
    text-decoration: none;
}

.end-border{
    margin-left:5%; 
    width:90%;
    
    border-style:solid;
    border-width:0.00005px;
    border-color: #ffffff;
    opacity: 0.5;

}

.side-border{
    
        height:90%;
        border-right: #ffffff;
        border-style: solid;
        border-width: 0.00005px;
        border-color: #ffffff;
        opacity: 0.5;
}

.copyright p{
    color:#ffffff;
    font-family: 'Inter',sans-serif;
    font-weight: 500;
    font-size: 13px;

}


@media screen and (max-width:768px){
    .footer {
            background-color: #E42727;
            display: flex;
            flex-direction: column;
        }
        .brand-container {
            width: 80%;
            padding: 50px;
            border-right: rgba(0, 0, 0, 0.1);
            border-style: solid;
            border-width: 0.005px;
            border-left: none;
            border-top: none;
            border-bottom: rgba(0, 0, 0, 0.1);
    
        }
        .contact-details {
            display: flex;
            width: 80%;
            flex-direction: column;
            margin-left: 50px;
            align-items: center;
            justify-content: center;
            margin-top: 20px;
        }
        .links {
            display: flex;
            flex-direction: column;
            width:60%;
            margin:0 auto;
            justify-content: start;
            align-items: center;
            margin-top: 20px;
            text-align: left;
           
        }
        .links a{
            /* margin-left:0px;
            margin-right:auto; */
        }
        .links-one{
            display: flex;
            flex-direction: column;
            width:60%;
            margin: 0 auto;
            align-items: center;
            margin-top: 20px;
            text-align: left;
        }
        .links-one a{
            /* margin-left:10%;
            margin-right:auto; */
        }
    
}
`, "",{"version":3,"sources":["webpack://./src/Styles/Footer.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,QAAQ;IACR,UAAU;IACV,sBAAsB;AAC1B;;AAEA;AACA,yBAAyB;AACzB,aAAa;AACb,SAAS;;AAET;;;;;AAKA;IACI,SAAS;IACT,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,gCAAgC;;AAEpC;AACA;IACI,SAAS;AACb;;AAEA;IACI,+BAA+B;IAC/B,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,gCAAgC;IAChC,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,iBAAiB;;IAEjB,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,aAAa;IACb,6BAA6B;IAC7B,eAAe;IACf,eAAe;;AAEnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,+BAA+B;IAC/B,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;AACjB;AACA;IACI,gCAAgC;IAChC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,gCAAgC;IAChC,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gCAAgC;IAChC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;;AAElB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,gCAAgC;IAChC,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gCAAgC;IAChC,SAAS;IACT,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,SAAS;;IAET,kBAAkB;IAClB,sBAAsB;IACtB,qBAAqB;IACrB,YAAY;;AAEhB;;AAEA;;QAEQ,UAAU;QACV,qBAAqB;QACrB,mBAAmB;QACnB,uBAAuB;QACvB,qBAAqB;QACrB,YAAY;AACpB;;AAEA;IACI,aAAa;IACb,+BAA+B;IAC/B,gBAAgB;IAChB,eAAe;;AAEnB;;;AAGA;IACI;YACQ,yBAAyB;YACzB,aAAa;YACb,sBAAsB;QAC1B;QACA;YACI,UAAU;YACV,aAAa;YACb,gCAAgC;YAChC,mBAAmB;YACnB,qBAAqB;YACrB,iBAAiB;YACjB,gBAAgB;YAChB,iCAAiC;;QAErC;QACA;YACI,aAAa;YACb,UAAU;YACV,sBAAsB;YACtB,iBAAiB;YACjB,mBAAmB;YACnB,uBAAuB;YACvB,gBAAgB;QACpB;QACA;YACI,aAAa;YACb,sBAAsB;YACtB,SAAS;YACT,aAAa;YACb,sBAAsB;YACtB,mBAAmB;YACnB,gBAAgB;YAChB,gBAAgB;;QAEpB;QACA;YACI;gCACoB;QACxB;QACA;YACI,aAAa;YACb,sBAAsB;YACtB,SAAS;YACT,cAAc;YACd,mBAAmB;YACnB,gBAAgB;YAChB,gBAAgB;QACpB;QACA;YACI;gCACoB;QACxB;;AAER","sourcesContent":[".footer-container{\n    background-color: #E42727;\n    margin:0;\n    padding: 0;\n    box-sizing: border-box;\n}\n\n.footer{\nbackground-color: #E42727;\ndisplay: flex;\nmargin: 0;\n\n}\n\n\n\n\n.brand-container{\n    width:30%;\n    padding:50px;\n    border-right: none;\n    border-style:none;\n    border-width: 0.005px;\n    border-left:none;\n    border-top:none;\n    border-bottom:rgba(0, 0, 0, 0.1);\n\n}\n.brand-container img{\n    width:80%;\n}\n\n.brand-container p{\n    font-family: 'Inter',sans-serif;\n    font-weight: 400;\n    font-size:14px;\n    color:#ffffff;\n    text-align:center;\n    line-height: 22px;\n    margin-top: -10px;\n    letter-spacing: 1px;\n}\n.brand-container h5 {\n    font-family: 'Inter', sans-serif;\n    font-weight: 400;\n    font-size: 14px;\n    color: #ffffff;\n    text-align: center;\n    line-height: 22px;\n    \n    letter-spacing: 1px;\n}\n\n.social{\n    width:50%;\n    display: flex;\n    justify-content: space-evenly;\n    margin-left:20%;\n    cursor: pointer;\n    \n}\n\n.links{\n    display: flex;\n    flex-direction: column;\n    margin-left: 30px;\n    justify-content:start;\n    margin-top: 150px;\n}\n\n.links h5{\n    font-family: 'Inter',sans-serif;\n    font-weight: 700;\n    font-size: 14px;\n    letter-spacing: 1px;\n    text-align: left;\n    color:#ffffff;\n}\n.links a {\n    font-family: 'Inter', sans-serif;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 22px;\n    letter-spacing: 1px;\n    text-align: left;\n    color: #ffffff;\n}\n\n.links-one {\n    display: flex;\n    flex-direction: column;\n    margin-left: 30px;\n    justify-content: start;\n    margin-top: 150px;\n}\n\n.links-one h5 {\n    font-family: 'Inter', sans-serif;\n    font-weight: 700;\n    font-size: 14px;\n    letter-spacing: 1px;\n    text-align: left;\n    color: #ffffff;\n}\n\n.links-one a {\n    font-family: 'Inter', sans-serif;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 22px;\n    letter-spacing: 1px;\n    text-align: left;\n    color: #ffffff;\n    \n}\n\n.contact-details {\n    display: flex;\n    width:fit-content;\n    flex-direction: column;\n    margin-left: 0px;\n    align-items:center;\n    justify-content:start;\n    margin-top: 150px;\n}\n\n.contact-details h5 {\n    font-family: 'Inter', sans-serif;\n    font-weight: 700;\n    font-size: 14px;\n    letter-spacing: 1px;\n    line-height: 22px;\n    text-align: left;\n    color: #ffffff;\n}\n\n.contact-details p {\n    font-family: 'Inter', sans-serif;\n    width:80%;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 22px;\n    letter-spacing: 1px;\n    text-align: center;\n    margin-top: 0px;\n    color: #ffffff;\n    text-decoration: none;\n}\n\n.end-border{\n    margin-left:5%; \n    width:90%;\n    \n    border-style:solid;\n    border-width:0.00005px;\n    border-color: #ffffff;\n    opacity: 0.5;\n\n}\n\n.side-border{\n    \n        height:90%;\n        border-right: #ffffff;\n        border-style: solid;\n        border-width: 0.00005px;\n        border-color: #ffffff;\n        opacity: 0.5;\n}\n\n.copyright p{\n    color:#ffffff;\n    font-family: 'Inter',sans-serif;\n    font-weight: 500;\n    font-size: 13px;\n\n}\n\n\n@media screen and (max-width:768px){\n    .footer {\n            background-color: #E42727;\n            display: flex;\n            flex-direction: column;\n        }\n        .brand-container {\n            width: 80%;\n            padding: 50px;\n            border-right: rgba(0, 0, 0, 0.1);\n            border-style: solid;\n            border-width: 0.005px;\n            border-left: none;\n            border-top: none;\n            border-bottom: rgba(0, 0, 0, 0.1);\n    \n        }\n        .contact-details {\n            display: flex;\n            width: 80%;\n            flex-direction: column;\n            margin-left: 50px;\n            align-items: center;\n            justify-content: center;\n            margin-top: 20px;\n        }\n        .links {\n            display: flex;\n            flex-direction: column;\n            width:60%;\n            margin:0 auto;\n            justify-content: start;\n            align-items: center;\n            margin-top: 20px;\n            text-align: left;\n           \n        }\n        .links a{\n            /* margin-left:0px;\n            margin-right:auto; */\n        }\n        .links-one{\n            display: flex;\n            flex-direction: column;\n            width:60%;\n            margin: 0 auto;\n            align-items: center;\n            margin-top: 20px;\n            text-align: left;\n        }\n        .links-one a{\n            /* margin-left:10%;\n            margin-right:auto; */\n        }\n    \n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
